//#region ../src/ar/qr/qr-frontend.ts
const defaultToImageData = (image) => new ImageData(new Uint8ClampedArray(image.data), image.width, image.height);
var BarcodeDetectorFrontEnd = class {
	kind = "barcode-detector";
	detector;
	toSource;
	constructor(detector, toSource = defaultToImageData) {
		this.detector = detector;
		this.toSource = toSource;
	}
	async detect(image) {
		const results = await this.detector.detect(this.toSource(image));
		for (const r of results) {
			const corners = toQuad(r.cornerPoints);
			if (corners && typeof r.rawValue === "string" && r.rawValue.length > 0) return {
				corners,
				text: r.rawValue
			};
		}
		return null;
	}
};
/**
* Build a {@link BarcodeDetectorFrontEnd} if the runtime exposes a
* `BarcodeDetector` constructor; otherwise `null` (→ the caller must handle the
* unsupported-browser case; there is no OpenCV fallback). `ctor` is injectable
* for tests.
*/
function createBarcodeDetectorFrontEnd(ctor) {
	const Ctor = ctor ?? globalThis.BarcodeDetector;
	if (!Ctor) return null;
	return new BarcodeDetectorFrontEnd(new Ctor({ formats: ["qr_code"] }));
}
function toQuad(points) {
	if (points.length !== 4) return null;
	const [a, b, c, d] = points;
	if (!a || !b || !c || !d) return null;
	const out = [
		{
			x: a.x,
			y: a.y
		},
		{
			x: b.x,
			y: b.y
		},
		{
			x: c.x,
			y: c.y
		},
		{
			x: d.x,
			y: d.y
		}
	];
	if (out.some((p) => !Number.isFinite(p.x) || !Number.isFinite(p.y))) return null;
	return out;
}
//#endregion
export { BarcodeDetectorFrontEnd, createBarcodeDetectorFrontEnd };
